// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"managers-module--wrapper--soCxv","imgWrapper":"managers-module--imgWrapper--2gM8q"};